import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Modal, notification, Row } from "antd";
import dayjs from "dayjs";

import { POST } from "../../../../providers/useAxiosQuery";
import { userData } from "../../../../providers/companyInfo";
import {
	checkNetworkStatus,
	readFile,
	setFileStorage,
} from "../../../../providers/useCapacitorStorage";
import notificationErrors from "../../../../providers/notificationErrors";
import QuestionContentPreview from "./QuestionContentPreview";

export default function ModalPreviewAnswer(props) {
	const { toggleModalPreview, setToggleModalPreview, dataSource, answers } =
		props;

	const navigate = useNavigate();

	const [isLoadingSurvey, setIsLoadingSurvey] = useState(false);

	const { mutate: mutateSurvey } = POST(
		`api/form_question_answer_batch`,
		"form_question_answer_single_store",
	);

	const onFinishPreview = async () => {
		setIsLoadingSurvey(true);
		// console.log("onFinishPreview: ", dataSource.form_question_categories);

		let form_question_categories = dataSource.form_question_categories.map(
			(item) => {
				return {
					...item,
					form_questions: item.form_questions.reduce((acc, item2) => {
						const idsToSave = item2.add_another
							? getUniqueAnswerSets(item2.id, answers)
							: [];

						// console.log("onFinishPreview idsToSave3: ", idsToSave);
						if (!idsToSave.length) {
							idsToSave.push(`q_${item2.id}`);
						}

						// console.log(`onFinishPreview item2 id ${item2.id}`, item2);
						// console.log(
						// 	`onFinishPreview item2 item2.add_another ${item2.add_another}`,
						// );
						// console.log("onFinishPreview idsToSave1: ", idsToSave);

						idsToSave.forEach((id) => {
							// console.log("onFinishPreview id: ", id);
							let answer = extractQuestionAnswer(
								id,
								item2.question_type,
								answers,
							);
							let form_question_options = extractQuestionOptionAnswer(
								id,
								item.form_id,
								item.id,
								item2.id,
								null,
								item2.form_question_options,
								answers,
							);
							// console.log("onFinishPreview answer1: ", answer);

							if (
								hasAnswerValue(answer) ||
								hasAnyOptionAnswer(form_question_options)
							) {
								// console.log("onFinishPreview answer2: ", answer);
								acc.push({
									...item2,
									user_id: userData().id,
									form_id: item.form_id,
									form_question_category_id: item.id,
									form_question_id: item2.id,
									answer: hasAnswerValue(answer) ? answer : null,
									form_question_options: form_question_options,
								});
							}
						});

						return acc;
					}, []),
				};
			},
		);

		let dataAnswers = [];
		form_question_categories.forEach((item) => {
			item.form_questions.forEach((item2) => {
				dataAnswers.push({
					user_id: userData().id,
					form_id: item2.form_id,
					form_question_category_id: item2.form_question_category_id,
					form_question_id: item2.form_question_id,
					answer: item2.answer,
				});

				if (item2.form_question_options.length) {
					dataAnswers = dataAnswers.concat(
						extractSubAnswerToSave(item2.form_question_options),
					);
				}
			});
		});

		let currentLocations = localStorage.getItem("currentLocations")
			? JSON.parse(localStorage.getItem("currentLocations"))
			: {};

		let coords =
			currentLocations && currentLocations.coords
				? currentLocations.coords
				: {};

		let data_survey_pending_list_to_save = {
			...dataSource,
			batch: {
				user_id: userData().id,
				form_id: dataSource.id,
				latitude: coords.latitude,
				longitude: coords.longitude,
				accuracy: coords.accuracy,
				altitude: coords.altitude,
				heading: coords.heading,
				altitude_accuracy: coords.altitudeAccuracy,
				speed: coords.speed,
				date_end_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
				date_start_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
			},
			form_question_categories,
			survey_status: "Ready to Upload",
		};

		// console.log(
		// 	"onFinishPreview data_survey_pending_list_to_save: ",
		// 	data_survey_pending_list_to_save,
		// );
		// console.log("onFinishPreview dataAnswers: ", dataAnswers);

		try {
			let resCheckNetworkStatus = await checkNetworkStatus();

			if (resCheckNetworkStatus?.connected) {
				// connected
				mutateSurvey(
					{
						answer_list: dataAnswers,
						batch: {
							user_id: userData().id,
							form_id: dataSource.id,
							latitude: coords.latitude,
							longitude: coords.longitude,
							accuracy: coords.accuracy,
							altitude: coords.altitude,
							heading: coords.heading,
							altitude_accuracy: coords.altitudeAccuracy,
							speed: coords.speed,
							date_end_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
							date_start_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
						},
					},
					{
						onSuccess: (res2) => {
							if (res2.success) {
								notification.success({
									message: "Survey",
									description: res2.message,
								});
							} else {
								notification.error({
									message: "Survey",
									description: res2.message,
								});
								readSaveToFile(
									data_survey_pending_list_to_save,
									"Server error occurred and your data has been saved on this device",
								);
							}
							setIsLoadingSurvey(false);
							navigate(-1);
						},
						onError: (err) => {
							setIsLoadingSurvey(false);
							notificationErrors(err);
							readSaveToFile(
								data_survey_pending_list_to_save,
								"Server error occurred and your data has been saved on this device.",
							);
							navigate(-1);
						},
					},
				);
			} else {
				readSaveToFile(data_survey_pending_list_to_save);
				navigate(-1);
			}
		} catch (error) {
			readSaveToFile(
				data_survey_pending_list_to_save,
				"Connection lost, and your data has been saved on this device.",
			);
			navigate(-1);
		}
	};

	const readSaveToFile = async (data, message) => {
		try {
			let data_survey_pending_list = await readFile(
				"fsuu_dsac_survey_sk/survey_pending_list.txt",
			);

			if (data_survey_pending_list && data_survey_pending_list.data) {
				data_survey_pending_list = JSON.parse(data_survey_pending_list.data);

				data_survey_pending_list.push(data);

				setFileStorage(
					"fsuu_dsac_survey_sk",
					"survey_pending_list",
					data_survey_pending_list,
				).then(() => {
					setIsLoadingSurvey(false);
					notification.info({
						message: "Survey",
						description: message,
					});
				});
			} else {
				setFileStorage("fsuu_dsac_survey_sk", "survey_pending_list", [
					data,
				]).then(() => {
					setIsLoadingSurvey(false);
					notification.info({
						message: "Survey",
						description: message,
					});
				});
			}
		} catch (error) {
			setFileStorage("fsuu_dsac_survey_sk", "survey_pending_list", [data]).then(
				() => {
					setIsLoadingSurvey(false);
					notification.info({
						message: "Survey",
						description: message,
					});
				},
			);
		}
	};

	const extractSubAnswerToSave = (form_question_options) => {
		let sub_answers = [];
		form_question_options.forEach((item) => {
			if (
				item.answer !== undefined &&
				item.answer !== null &&
				item.answer !== ""
			) {
				sub_answers.push({
					answer: item.answer,
					form_id: item.form_id,
					form_question_category_id: item.form_question_category_id,
					form_question_id: item.form_question_id,
					form_question_option_id: item.form_question_option_id,
					form_question_sub_option_id: item.form_question_sub_option_id,
					user_id: item.user_id,
				});
			}

			if (item.form_question_options.length) {
				let sub_answers_copy = extractSubAnswerToSave(
					item.form_question_options,
				);
				sub_answers = sub_answers.concat(sub_answers_copy);
			}
		});
		return sub_answers;
	};

	return (
		<Modal
			wrapClassName="modal-preview-answer"
			open={toggleModalPreview}
			title={dataSource && dataSource.form_name ? dataSource.form_name : ""}
			onCancel={() => setToggleModalPreview(false)}
			footer={
				<>
					<Button
						size="large"
						onClick={() => setToggleModalPreview(false)}
						disabled={isLoadingSurvey}
						className="btn-main-primary outlined br-30"
					>
						Close
					</Button>
					<Button
						size="large"
						onClick={() => onFinishPreview()}
						loading={isLoadingSurvey}
						className="btn-main-primary br-30"
					>
						Submit
					</Button>
				</>
			}
		>
			{dataSource && dataSource.form_question_categories
				? dataSource.form_question_categories.map((item, index) => {
						// console.log("form_question_categories item: ", item);
						// console.log("form_question_categories answers: ", answers);

						return (
							<Card key={index} title={item.category}>
								{item.form_questions && item.form_questions
									? item.form_questions.map((item2, index2) => {
											if (item2.add_another) {
												// console.log("form_questions item2: ", item2);
												// console.log("form_questions answers: ", answers);

												const uniqueSets = getUniqueAnswerSets(
													item2.id,
													answers,
												);

												// console.log("form_questions uniqueSets: ", uniqueSets);

												return (
													<Row key={index2}>
														<Col xs={24} sm={24} md={24} lg={24} xl={24}>
															{uniqueSets.length > 0 ? (
																uniqueSets.map((ans, ansIndex) => {
																	// console.log("form_questions ans: ", ans);

																	return (
																		<QuestionContentPreview
																			key={ans}
																			category={item.category}
																			id={[ans]}
																			question={`${item2.question}${
																				uniqueSets.length > 1
																					? ` (${ansIndex + 1})`
																					: ""
																			}`}
																			description={item2.description}
																			type={item2.question_type}
																			form_question_options={
																				item2.form_question_options.length
																					? item2.form_question_options
																					: []
																			}
																			answers={answers}
																		/>
																	);
																})
															) : (
																<QuestionContentPreview
																	category={item.category}
																	id={[`q_${item2.id}`]}
																	question={item2.question}
																	description={item2.description}
																	type={item2.question_type}
																	form_question_options={
																		item2.form_question_options.length
																			? item2.form_question_options
																			: []
																	}
																	answers={answers}
																	item2={item2}
																/>
															)}
														</Col>
													</Row>
												);
											}

											return (
												<Row key={index2}>
													<Col xs={24} sm={24} md={24} lg={24} xl={24}>
														<QuestionContentPreview
															category={item.category}
															id={[`q_${item2.id}`]}
															question={item2.question}
															description={item2.description}
															type={item2.question_type}
															form_question_options={
																item2.form_question_options.length
																	? item2.form_question_options
																	: []
															}
															answers={answers}
															item2={item2}
														/>
													</Col>
												</Row>
											);
									  })
									: ""}
							</Card>
						);
				  })
				: ""}
		</Modal>
	);
}

const extractQuestionAnswer = (id, type, answers) => {
	// console.log("extractQuestionAnswer id, type, answers: ", id, type, answers);

	if (!answers) {
		return null;
	}

	switch (type) {
		case "Text (Input)":
		case "Number (Input)":
		case "Select (Dropdown)":
		case "Date (Datepicker)":
		case "Time (Timepicker)":
		case "Radio (Button)":
		case "Checkbox":
		case "sub_question":
			let answer = hasAnswerValue(answers[id])
				? checkTypeAnswer(type, answers[id])
				: null;

			Object.keys(answers).forEach((key) => {
				if (key.includes("_other")) {
					if (hasAnswerValue(answers[key])) {
						// console.log("type, answers[key]: ", type, answers[key]);
						let q_id = key.split("_other")[0];
						if (q_id === id) {
							answer = answer ? answer + ": " + answers[key] : answers[key];
						}
					}
				}
			});

			// console.log("extractQuestionAnswer answer: ", answer);

			return answer;
		default:
			return null;
	}
};

const getUniqueAnswerSets = (questionId, answers) => {
	// console.log("getUniqueAnswerSets: ", questionId);

	if (!answers) return [];

	return [
		...new Set(
			Object.keys(answers)
				.filter((key) => key.startsWith(`q_${questionId}_set_`))
				.map((key) => {
					const match = key.match(new RegExp(`q_${questionId}_set_\\d+`));
					return match ? match[0] : null;
				})
				.filter(Boolean),
		),
	];
};

const checkTypeAnswer = (type, answer) => {
	// console.log("checkTypeAnswer: ", type, answer);

	switch (type) {
		case "Text (Input)":
		case "Number (Input)":
		case "Select (Dropdown)":
			return answer;
		case "Date (Datepicker)":
			return answer && dayjs(answer).isValid()
				? dayjs(answer).format("YYYY-MM-DD")
				: null;
		case "Time (Timepicker)":
			return answer && dayjs(answer).isValid()
				? dayjs(answer).format("HH:mm:ss")
				: null;
		case "Radio (Button)":
			return answer;
		case "Checkbox":
			return JSON.stringify(answer);
		case "sub_question":
			return answer ? answer : null;
		default:
			return null;
	}
};

const extractQuestionOptionAnswer = (
	id,
	form_id,
	form_question_category_id,
	form_question_id,
	form_question_option_id,
	form_question_options,
	answers,
) => {
	let new_form_question_options = [];
	form_question_options.forEach((item, optionIndex) => {
		let answer = item.sub_option_type
			? extractQuestionAnswer(
					`${id}_qo_${item.id}`,
					item.sub_option_type,
					answers,
			  )
			: null;

		let nested_options = extractQuestionOptionAnswer(
			`${id}_qo_${item.id}`,
			form_id,
			form_question_category_id,
			form_question_id,
			item.id,
			item.form_question_options || [],
			answers,
		);

		let indexed_nested_options = (item.form_question_options || [])
			.filter((x) => !x.is_other)
			.map((subItem, subIndex) => {
				const indexedKey = `${id}_option_${optionIndex}_sub_option_${subIndex}`;
				const rawAnswer = answers[indexedKey];
				const formattedAnswer = subItem.sub_option_type
					? checkTypeAnswer(subItem.sub_option_type, rawAnswer)
					: rawAnswer;

				return {
					user_id: userData().id,
					form_id,
					form_question_category_id,
					form_question_id,
					form_question_option_id: item.id,
					form_question_sub_option_id: subItem.id,
					option: subItem.option,
					sub_option_type: subItem.sub_option_type,
					sub_options: subItem.sub_options ?? null,
					answer: hasAnswerValue(formattedAnswer) ? formattedAnswer : null,
					form_question_options: [],
				};
			})
			.filter((subItem) => hasAnswerValue(subItem.answer));

		nested_options = nested_options.concat(indexed_nested_options);

		if (
			item.sub_option_type ||
			nested_options.length ||
			hasAnswerValue(answer)
		) {
			new_form_question_options.push({
				user_id: userData().id,
				form_id,
				form_question_category_id,
				form_question_id,
				form_question_option_id: form_question_option_id ?? item.id,
				form_question_sub_option_id: form_question_option_id ? item.id : null,
				option: item.option,
				sub_option_type: item.sub_option_type,
				sub_options: item.sub_options ?? null,
				answer,
				form_question_options: nested_options,
			});
		}
	});

	return new_form_question_options;
};

const hasAnswerValue = (value) => {
	if (value === undefined || value === null || value === "") {
		return false;
	}

	if (Array.isArray(value)) {
		return value.length > 0;
	}

	return true;
};

const hasAnyOptionAnswer = (form_question_options = []) => {
	return form_question_options.some((item) => {
		if (hasAnswerValue(item.answer)) {
			return true;
		}

		return hasAnyOptionAnswer(item.form_question_options || []);
	});
};
